<div class="blogs-cont" *ngIf="blog; else loading">
  
  <!-- Back Button -->
  <div class="back-button-container">
    <button class="back-button" [routerLink]="['/blogs']">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M19 12H5M12 19l-7-7 7-7"/>
      </svg>
      <span>Back</span>
    </button>
  </div>

  <!-- Publication Info -->
  <div class="pub-header">
    <span class="pub-date">Published {{ blog.publishedDate | date: 'MMM d, yyyy' }}</span>
    <span class="pub-author">By {{ blog.author || 'SEHYOG Academy' }}</span>
  </div>

  <!-- Blog Title -->
  <h1 class="blog-title">{{ blog.title }}</h1>

  <!-- Subtitle/Excerpt (if available) -->
  <p class="blog-subtitle" *ngIf="blog.subtitle">{{ blog.subtitle }}</p>

  <!-- Tags (if available) -->
  <div class="blog-tags" *ngIf="blog.tags && blog.tags.length">
    <span class="tag" *ngFor="let tag of blog.tags">{{ tag }}</span>
  </div>

  <!-- Blog Banner -->
  <div class="blog-banner">
    <img [src]="blog.image" [alt]="blog.title" />
  </div>

  <!-- Blog Content Section -->
  <div class="blog-content-wrapper">
    <!-- Introduction Section -->
    <section class="content-section">
      <h2 class="section-title">Introduction</h2>
      <div class="blog-content" [innerHTML]="blog.description"></div>
    </section>
    <!-- You can add more sections as needed -->
  </div>
</div>

<ng-template #loading>
  <div class="loading-container">
    <p>Loading blog...</p>
  </div>
</ng-template>